<script lang="ts" setup>
import { AppStandardModal } from '@libs/ui';
import type {
  Airport,
  Coordinate,
  FlightAutoCompleteSuggestion,
} from '@libs/trip-planner-interfaces';

import AirportSelector from './AirportSelector.vue';

interface AirportSelectorModalProps {
  initialAirport: Airport;
  initialUserPosition?: Coordinate;
}
const props = defineProps<AirportSelectorModalProps>();

interface AirportSelectorModalEmits {
  (eventName: 'cancel-modal'): void;
  (eventName: 'change-airport', newAirport: Airport): void;
}
const emit = defineEmits<AirportSelectorModalEmits>();

function emitNewAirport(airportSuggestion: FlightAutoCompleteSuggestion): void {
  emit('change-airport', {
    iata: airportSuggestion.iata,
    name: airportSuggestion.tooltip,
    displayingText: airportSuggestion.label,
  });
}
</script>

<template>
  <AppStandardModal @close="emit('cancel-modal')">
    <template #title>
      <div class="header-text">
        <slot name="header-text">
          {{ $t('planner.transport.fly_from') }}
        </slot>
      </div>
    </template>

    <template #body>
      <AirportSelector
        :initial-airport="props.initialAirport.displayingText"
        :initial-user-position="props.initialUserPosition"
        @airport-selected="emitNewAirport"
      />
    </template>
  </AppStandardModal>
</template>
